var subDomainUrl = process.env.PUBLIC_URL.split("/");
var dev = {
    rootUrl: "https://local.nuvamawealth.com:8080/",
    subDomain: "/bucket3",
    web_mw: "https://nwmwuat.nuvamawealth.com/EWMTrade/api/",
    streamUrl: "wss://ewstream.edelweiss.in/",
    jmwedel: "https://nmwuat1.nuvamawealth.com/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNjQ2MjAzNTAzLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2NDYyNDU4MDAsImlhdCI6MTY0NjIwMzgwM30.VCTEFN-PGmGoxUpUElRskqXEkqlvtJ43CbdUlCX1HmQ",
    jmw: "https://nmwuat1.nuvamawealth.com/",
    jmw_reports: "https://nmwuat1.nuvamawealth.com/",
    jmw_content: "edelmw-content-uat/content/",
    jmw_content_new: "edelmw-content-uat-revamp/content/",
    jmw_conten_no_revamp: "edelmw-content-uat/content/",
    jmw_news_content: "edelmw-spr-content-uat/",
    jmw_login: "edelmw-login-uat/login/",
    adminuat: "https://nmwadminuat.nuvamawealth.com/",
    appId: "9e5481c0130b8bba8190e52bdc5038ba",
    oldWebUrl: "https://vamauat.nuvamawealth.com/",
    edisUrl: "https://vamauat.nuvamawealth.com/edis",
    epledgeUrl: "https://vamauat.nuvamawealth.com/epledge",
    reportBase: "",
    baseEnvironment: "dev/",
    feReportBase: "/reports",
    revamp: "revamp/",
    jmw_content_kambala: "edelmw-content-uat/content/",
    eqedel: "edelmw-eq-uat/eq/",
    commedel: "edelmw-comm-uat/comm/",
    equity: "edelmw-eq-uat/eq/",
    commodity: "edelmw-comm-uat/comm/",
    accOpeningUrl: "https://onboardinguat.nuvamawealth.com/",
    kambalaBase: "",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    jmw_market: "app-marketstats/",
    appClient: "app-client/",
    jmw_mf: "edelmw-mf-uat/mf/",
    jmw_eq: "edelmw-eq-uat/eq/",
    jmw_market_env: "",
    edelmw_sr: "edelmw-sr-uat",
    edelmw_nse: "edelmw-nse-uat/nse/",
    jmw_payment: "edelmw-payment-uat/pay/",
    serviceRequest_base: "http://localhost:3001/clientarea/",
    sr_web: "",
    sr_lucidfox: "",
    app_mf: "app-mutualfund/",
    unpledgeurl: "https://vamauat.nuvamawealth.com/epledge/?unpledge",
    tradingviewBase: "https://vamauat.nuvamawealth.com/tradingview/",
    apiBaseElasticSearch: "https://reportsuat.edelweiss.in/",
    serverPublicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmPO93yLZ1mQSv3QSnJ8makU4ySPFRBmqw+fiUcGh9COzBIOw41sHS3WnH5p0DqjTEXEoSbU2LNolYmXZuP61IIb9A/8SMLJHLMVOsgdJOXhy5jJFAkvmp6JPB25cYig5XIuSSa58K6Da7yHOPABl3x5+8blWeH/nv1l4qrvbsikGTglh3nn+sbMQGUH2/K5sWazcqmCneo/rAZuqWbEds2+k+vypDFfWhBkuY2s14OTRxGU6stAqcLIGlfJevjx1Toju5teJHIhRV2o/DbbYg5DS0/lp+L8O0pNXOgr/6XVX0Td24BxKO2WNPjmB4QDcNpsJfHh8PGQwVs4arGdIaQIDAQAB",
};
export var uat = {
    rootUrl: "https://vamauat.nuvamawealth.com/" + "bucket1/",
    // rootUrl: "https://vamauat.nuvamawealth.com/" + "bucket3/", //uncomment when deploying on bucket3
    // subDomain: "/bucket1", // uncomment when deploying on bucket1
    subDomain: "/bucket1",
    web_mw: "https://nwmwuat.nuvamawealth.com/EWMTrade/api/",
    streamUrl: "wss://ewstream.edelweiss.in/",
    jmwedel: "https://nmwuat1.nuvamawealth.com/",
    jmw: "https://nmwuat1.nuvamawealth.com/",
    jmw_reports: "https://nmwuat1.nuvamawealth.com/",
    jmw_content: "edelmw-content-uat/content/",
    jmw_conten_no_revamp: "edelmw-content-uat/content/",
    jmw_news_content: "edelmw-spr-content-uat/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNjQ2MjAzNTAzLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNjYzMDUxY2ZiYWM3ZDY5OWExYzU5Yjk2MDQ4YjUwZTciLCJpc3MiOiJlbXQiLCJleHAiOjE2NDYyNDU4MDAsImlhdCI6MTY0NjIwMzgwM30.VCTEFN-PGmGoxUpUElRskqXEkqlvtJ43CbdUlCX1HmQ",
    jmw_login: "edelmw-login-uat/login/",
    adminuat: "https://nmwadminuat.nuvamawealth.com/",
    appId: "9e5481c0130b8bba8190e52bdc5038ba",
    oldWebUrl: "https://vamauat.nuvamawealth.com/",
    edisUrl: "https://vamauat.nuvamawealth.com/edis",
    epledgeUrl: "https://vamauat.nuvamawealth.com/epledge",
    reportBase: "",
    baseEnvironment: "dev/",
    feReportBase: "/reports",
    revamp: "revamp/",
    jmw_content_kambala: "edelmw-content-uat/content/",
    eqedel: "edelmw-eq-uat/eq/",
    commedel: "edelmw-comm-uat/comm/",
    equity: "edelmw-eq-uat/eq/",
    commodity: "edelmw-comm-uat/comm/",
    accOpeningUrl: "https://onboardinguat.nuvamawealth.com/",
    kambalaBase: "",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    appClient: "app-client/",
    jmw_market: "app-marketstats/",
    jmw_mf: "edelmw-mf-uat/mf/",
    jmw_eq: "edelmw-eq-uat/eq/",
    jmw_market_env: "",
    edelmw_sr: "edelmw-sr-uat",
    edelmw_nse: "edelmw-nse-uat/nse/",
    jmw_payment: "edelmw-payment-uat/pay/",
    serviceRequest_base: "https://vamauat.nuvamawealth.com/",
    sr_web: "app/clientarea/",
    sr_lucidfox: "clientarea/",
    app_mf: "app-mutualfund/",
    unpledgeurl: "https://vamauat.nuvamawealth.com/epledge/?unpledge",
    tradingviewBase: "https://vamauat.nuvamawealth.com/tradingview/",
    apiBaseElasticSearch: "https://reportsuat.edelweiss.in/",
    serverPublicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmPO93yLZ1mQSv3QSnJ8makU4ySPFRBmqw+fiUcGh9COzBIOw41sHS3WnH5p0DqjTEXEoSbU2LNolYmXZuP61IIb9A/8SMLJHLMVOsgdJOXhy5jJFAkvmp6JPB25cYig5XIuSSa58K6Da7yHOPABl3x5+8blWeH/nv1l4qrvbsikGTglh3nn+sbMQGUH2/K5sWazcqmCneo/rAZuqWbEds2+k+vypDFfWhBkuY2s14OTRxGU6stAqcLIGlfJevjx1Toju5teJHIhRV2o/DbbYg5DS0/lp+L8O0pNXOgr/6XVX0Td24BxKO2WNPjmB4QDcNpsJfHh8PGQwVs4arGdIaQIDAQAB",
};
export var cug = {
    // rootUrl: "https://vamacug.nuvamawealth.com/cug/alpha/revamp/", //uncomment when deploying on revamp
    // rootUrl: "https://vamacug.nuvamawealth.com/cug/alpha/bucket1/", //uncomment when deploying on bucket1
    rootUrl: "https://vamacug.nuvamawealth.com/cug/alpha/bucket3/",
    // subDomain: "/cug/alpha/bucket1", // uncomment when deploying on bucket1
    subDomain: "/cug/alpha/bucket3",
    web_mw: "https://nwmwcug.nuvamawealth.com/api/",
    streamUrl: "wss://nwst.nuvamawealth.com/",
    jmwedel: "https://nmwcug.nuvamawealth.com/",
    jmw: "https://nmwcug.nuvamawealth.com/",
    jmw_reports: "https://nmwcug.nuvamawealth.com/",
    jmw_content: "edelmw-content-cug-revamp/content/",
    jmw_conten_no_revamp: "edelmw-content-cug/content/",
    jmw_news_content: "edelmw-spr-content-cug/",
    jmw_login: "edelmw-login-cug/login/",
    adminuat: "https://nmwcug.nuvamawealth.com/",
    appId: "4fe68b7536784e3407c3ecf19be7c4ad",
    oldWebUrl: "https://vamacug.nuvamawealth.com/",
    edisUrl: "https://vamacug.nuvamawealth.com/edis",
    epledgeUrl: "https://vamacug.nuvamawealth.com/epledge",
    reportBase: "cug/",
    baseEnvironment: "cug/",
    feReportBase: "/reports",
    revamp: "",
    jmw_content_kambala: "edelmw-content-cug-revamp/content/",
    eqedel: "edelmw-eq-cug/eq/",
    commedel: "edelmw-comm-cug/comm/",
    equity: "edelmw-eq-cug/eq/",
    commodity: "edelmw-comm-cug/comm/",
    accOpeningUrl: "https://onboarding.nuvamawealth.com/",
    kambalaBase: "",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    appClient: "app-client/",
    jmw_market: "app-marketstats/",
    jmw_mf: "edelmw-mf-cug/mf/",
    jmw_eq: "edelmw-eq-cug/eq/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
    jmw_market_env: "cug/",
    edelmw_sr: "edelmw-sr-cug",
    edelmw_nse: "edelmw-nse-cug/nse/",
    jmw_payment: "edelmw-payment-cug/pay/",
    serviceRequest_base: "https://vamacug.nuvamawealth.com/",
    sr_web: "app/clientarea/",
    sr_lucidfox: "clientarea/",
    app_mf: "app-mutualfund/",
    unpledgeurl: "https://vamacug.nuvamawealth.com/epledge/?unpledge",
    tradingviewBase: "https://www.nuvamawealth.com/tradingview/",
    apiBaseElasticSearch: "https://nwopmscug.nuvamawealth.com/",
    serverPublicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmPO93yLZ1mQSv3QSnJ8makU4ySPFRBmqw+fiUcGh9COzBIOw41sHS3WnH5p0DqjTEXEoSbU2LNolYmXZuP61IIb9A/8SMLJHLMVOsgdJOXhy5jJFAkvmp6JPB25cYig5XIuSSa58K6Da7yHOPABl3x5+8blWeH/nv1l4qrvbsikGTglh3nn+sbMQGUH2/K5sWazcqmCneo/rAZuqWbEds2+k+vypDFfWhBkuY2s14OTRxGU6stAqcLIGlfJevjx1Toju5teJHIhRV2o/DbbYg5DS0/lp+L8O0pNXOgr/6XVX0Td24BxKO2WNPjmB4QDcNpsJfHh8PGQwVs4arGdIaQIDAQAB",
};
export var prod = {
    rootUrl: "https://www.nuvamawealth.com/beta/",
    subDomain: "/beta",
    web_mw: "https://nwmw.nuvamawealth.com/api/",
    streamUrl: "wss://nwst.nuvamawealth.com",
    jmwedel: "https://nw.nuvamawealth.com/",
    jmw: "https://nw.nuvamawealth.com/",
    jmw_reports: "https://nw.nuvamawealth.com/",
    jmw_content: "edelmw-content/content/",
    jmw_conten_no_revamp: "edelmw-content/content/",
    jmw_news_content: "edelmw-spr-content/",
    jmw_login: "edelmw-login/login/",
    adminuat: "https://nw.nuvamawealth.com/",
    appId: "4fe68b7536784e3407c3ecf19be7c4ad",
    oldWebUrl: "https://www.nuvamawealth.com/",
    edisUrl: "https://www.nuvamawealth.com/edis",
    epledgeUrl: "https://www.nuvamawealth.com/epledge",
    reportBase: "",
    baseEnvironment: "",
    feReportBase: "/reports",
    revamp: "",
    jmw_content_kambala: "edelmw-content/content/content/",
    eqedel: "edelmw-eq/eq/",
    commedel: "edelmw-comm/comm/",
    equity: "edelmw-eq/eq/",
    commodity: "edelmw-comm/comm/",
    accOpeningUrl: "https://onboarding.nuvamawealth.com/",
    kambalaBase: "",
    kambalaSwitch: true,
    web_config_access_reports: "new-features/",
    appClient: "app-client/",
    jmw_market: "app-marketstats/",
    jmw_mf: "edelmw-mf/mf/",
    jmw_eq: "edelmw-eq/eq/",
    appIdKey: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHAiOjEsImZmIjoiVyIsImJkIjoid2ViLXBjIiwibmJmIjoxNTc5MjQxODMyLCJzcmMiOiJlbXRtdyIsImF2IjoiMS4wLjAuNCIsImFwcGlkIjoiNGZlNjhiNzUzNjc4NGUzNDA3YzNlY2YxOWJlN2M0YWQiLCJpc3MiOiJlbXQiLCJleHAiOjE2MTA3NzgxMzIsImlhdCI6MTU3OTI0MjEzMn0.IR-PKf1Jjr69bsERFmMeuZrZ2RafBDiTGgKA6Ygofdo",
    jmw_market_env: "",
    edelmw_sr: "edelmw-sr",
    edelmw_nse: "edelmw-nse/nse/",
    jmw_payment: "edelmw-payment/pay/",
    serviceRequest_base: "https://www.nuvamawealth.com/",
    sr_web: "app/clientarea/",
    sr_lucidfox: "clientarea/",
    app_mf: "app-mutualfund/",
    unpledgeurl: "https://www.nuvamawealth.com/epledge/?unpledge",
    tradingviewBase: "https://www.nuvamawealth.com/tradingview/",
    apiBaseElasticSearch: "",
    serverPublicKey: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAmPO93yLZ1mQSv3QSnJ8makU4ySPFRBmqw+fiUcGh9COzBIOw41sHS3WnH5p0DqjTEXEoSbU2LNolYmXZuP61IIb9A/8SMLJHLMVOsgdJOXhy5jJFAkvmp6JPB25cYig5XIuSSa58K6Da7yHOPABl3x5+8blWeH/nv1l4qrvbsikGTglh3nn+sbMQGUH2/K5sWazcqmCneo/rAZuqWbEds2+k+vypDFfWhBkuY2s14OTRxGU6stAqcLIGlfJevjx1Toju5teJHIhRV2o/DbbYg5DS0/lp+L8O0pNXOgr/6XVX0Td24BxKO2WNPjmB4QDcNpsJfHh8PGQwVs4arGdIaQIDAQAB",
};
export var urlConstructor = function (mainBase, base, endPoint) {
    return "".concat(config.jmw).concat(process.env.NODE_ENV === "cug" ? config.baseEnvironment : "").concat(mainBase !== null && mainBase !== void 0 ? mainBase : "").concat(base !== null && base !== void 0 ? base : "").concat(endPoint !== null && endPoint !== void 0 ? endPoint : "");
};
export var config = process.env.NODE_ENV === "production"
    ? prod
    : process.env.NODE_ENV === "cug"
        ? cug
        : process.env.NODE_ENV === "uat"
            ? uat
            : dev;
export default config;
